import { useSyncExternalStore } from 'react';
import { api } from '../api';

const KEY = 'ysm.visited.v1';

function load(): Set<string> {
  try {
    return new Set(JSON.parse(localStorage.getItem(KEY) ?? '[]') as string[]);
  } catch {
    return new Set();
  }
}

let cache = load();
let version = 0;
const listeners = new Set<() => void>();

let signedIn = false;
/** Called once `/me` resolves, so `toggle` knows whether to sync to the server too. */
export function setSignedIn(v: boolean) {
  signedIn = v;
}

/** "Been there" check marks, kept only in this browser (and synced to the account when signed in). */
export const visited = {
  has: (id: string) => cache.has(id),
  all: () => new Set(cache),
  toggle(id: string) {
    if (cache.has(id)) cache.delete(id);
    else cache.add(id);
    try {
      localStorage.setItem(KEY, JSON.stringify([...cache]));
    } catch {
      /* ignore */
    }
    if (signedIn) api.postJson(`/visits/${id}/toggle`).catch(() => {});
    version++;
    listeners.forEach((l) => l());
  },
  subscribe(l: () => void) {
    listeners.add(l);
    return () => {
      listeners.delete(l);
    };
  },
};

/** Re-render when any check mark changes. */
export function useVisitedVersion(): number {
  return useSyncExternalStore(visited.subscribe, () => version);
}

export function reloadVisited() {
  cache = load();
}

/** Snapshot of locally-marked "been there" event ids, used by the sign-in flow to merge them
 * into the account server-side (see `/visits/merge`, added alongside `user_visits` in Task 3). */
export function snapshotForMerge(): string[] {
  return [...cache];
}
